import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import supabase from '../../../../supabaseClient';
import { useAuth } from '../../../../contexts/authContext';

const ManagerLMSLayout = () => {
  const [pendingEvaluations, setPendingEvaluations] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    supabase.rpc('count_pending_evaluations_for_manager')
      .then(({ data, error }) => {
        if (error) {
          console.error('Error fetching pending evaluations:', error);
          setPendingEvaluations(0);
        } else {
          setPendingEvaluations(data || 0);
        }
      });
  }, [user]);

  return (
    <div className="lms-layout">
      <main className="lms-main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
};

export default ManagerLMSLayout;
